import { DayScheduleInfo } from './day-schedule-info';

export class Schedule {
  name: string;
  caption: string;
  sequence: string;
  startDate: Date;
  endDate: Date;
  additionalDates: Array <any>;
  dayScheduleInfo: DayScheduleInfo[];
  dayScheduleInfoGroupped: DayScheduleInfo[];

  constructor(
    name: string,
    caption: string,
    sequence: string,
    startDate: Date,
    endDate: Date,
    additionalDates: Array <any>,
    dayScheduleInfo: DayScheduleInfo[],
    dayScheduleInfoGroupped: DayScheduleInfo[],
  ) {
    this.name = name;
    this.caption = caption;
    this.sequence = sequence;
    this.startDate = startDate;
    this.endDate = endDate;
    this.additionalDates = additionalDates;
    this.dayScheduleInfo = dayScheduleInfo;
    this.dayScheduleInfoGroupped = dayScheduleInfoGroupped;
  }

  static arrayFromJSON(json: string): Schedule {
    const value = JSON.parse(json);
    if (!value) {
      return null;
    }

    let result: Schedule = null;
    result = Schedule.createFromAny(value);

    return result;
  }

  static createFromAny(object: any): Schedule {
    if (object === null || object === undefined) {
      return null;
    }

    const dayScheduleInfo = object.dayScheduleInfo ? object.dayScheduleInfo.map(x => DayScheduleInfo.createFromAny(x)).sort((n1, n2) => n1.sequence - n2.sequence)  : [];
    const dayScheduleInfoGroupped = object.dayScheduleInfoGroupped ? object.dayScheduleInfoGroupped.map(x => DayScheduleInfo.createFromAny(x)).sort((n1, n2) => n1.sequence - n2.sequence)  : [];

    return new Schedule(
      object.name,
      object.caption,
      object.sequence,
      object.startDate ? new Date(object.startDate) : null,
      object.endDate ? new Date(object.endDate) : null,
      object.additionalDates,
      dayScheduleInfo,
      dayScheduleInfoGroupped,
    );
  }
}
